import auth from "@auth";
import { GET_REFRESH_TOKEN } from "@/services/local.storage.service";
import router from "@/router";

export default {
  async LOGIN({ commit, dispatch }, payload) {
    let resp = await auth.post("auth/token", payload);
    commit("SET_TOKEN", resp.accessToken);
    commit("SET_REFRESH_TOKEN", resp.refreshToken);
    await dispatch("GET_USER");
  },
  async REFRESH_TOKEN({ commit, dispatch }) {
    try {
      let resp = await auth.post("auth/refreshtoken", { refreshToken: GET_REFRESH_TOKEN() });
      commit("SET_TOKEN", resp.accessToken);
      commit("SET_REFRESH_TOKEN", resp.refreshToken);
      dispatch("GET_USER");
    } catch (error) {
      dispatch("START_LOGIN");
    }
  },
  async GET_USER({ commit, dispatch }) {
    let user = await auth.get("me");
    commit("SET_USER", user);
    await dispatch("AFTER_LOGIN");
  },
  async LOGOUT({ commit }) {
    auth.post(`auth/revoke`, { token: GET_REFRESH_TOKEN() });
    commit("SET_TOKEN", null);
    commit("SET_USER", null);
    commit("SET_REFRESH_TOKEN", null);
    router.push({ name: "auth-login" });
  },
  async START_LOGIN({ commit }) {
    commit("SET_TOKEN", null);
    commit("SET_USER", null);
    commit("SET_REFRESH_TOKEN", null);
    router.push({ name: "auth-login" });
  },
  async AFTER_LOGIN({ dispatch }) {
    await dispatch("parameter/getAgentList", null, { root: true });
    await dispatch("parameter/getPaymentAccountList", null, { root: true });
    await dispatch("parameter/getTrxTypeList", null, { root: true });
  }
};
